var map = {
	"./0.jpg": 8517,
	"./1.jpg": 1256,
	"./10.jpg": 6594,
	"./2.jpg": 183,
	"./3.jpg": 8797,
	"./4.jpg": 3769,
	"./5.jpg": 6396,
	"./6.jpg": 4091,
	"./7.jpg": 7630,
	"./8.jpg": 2637,
	"./9.jpg": 9184
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6560;